// extracted by mini-css-extract-plugin
export var rootform = "form-module--rootform--YutmI";
export var containerfluid = "form-module--containerfluid--DMoFl";
export var head = "form-module--head--DXinX";
export var btn = "form-module--btn--6MTyZ";
export var input = "form-module--input--95xQE";
export var accept = "form-module--accept--e2+cj";